const Worker = require('./Worker');
const StandardPlugin = require('./StandardPlugin');

module.exports = {
  StandardPlugin, Worker,
};
